export enum MyCommunityCategories {
    Budget = 'budget',
    Committees = 'committees',
    Meetings = 'meetings',
    Violation = 'violation',
    Communication = 'communication',
    Requests = 'requests'
}